export default {
  SET_ACTIVE_DESCRIPTION: 'SET_ACTIVE_DESCRIPTION',
};



// WEBPACK FOOTER //
// ./src/screens/Class/Details/Description/store/types.js